import { render, staticRenderFns } from "./decoration.vue?vue&type=template&id=7785d39b&scoped=true"
import script from "./decoration.vue?vue&type=script&lang=ts"
export * from "./decoration.vue?vue&type=script&lang=ts"
import style0 from "./decoration.vue?vue&type=style&index=0&id=7785d39b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7785d39b",
  null
  
)

export default component.exports